import eu from "../../../../assets/images/eu-4.png";
import eu1 from "../../../../assets/images/eu1.png";
import "./MainFooter.scss"

const MainFooter = () => {
  return (
    <footer style={{ marginTop: 'auto' }}>
      <div className="main-footer footer clearfix mb-0 text-muted">
        <div className="float-start flex-row">
          <p style={{ fontSize: "12px" }}><b>Наименование на проекта:</b> Дигитализация на предприятията<br /><b>Краен получател:</b> ДИЕЛ - Монтаж ЕООД<br /><b>Номер на проект:</b> BG16RFPR001-1.012<br/><b>Обща стойност:</b> 8 223,11 EUR, от които 5 756,18 EUR безвъзмездно финансиране.<br/><b>Начало:</b> 02.01.2026г.<br/><b>Край:</b> 02.01.2027г.</p>
        </div>
        <div className="d-flex flex-row">
          <img src={eu} alt="EU" style={{ height: "8vh" }} />
          <img src={eu1} alt="EU" style={{ height: "8vh" }} />
        </div>
      </div>
    </footer >
  )
}


export default MainFooter;